import { FC } from 'react'
import cn from 'classnames'
import type { CrmLeadParent } from '@/api/types/crm/crmLeadParent.types'
import {
  getParentIntegrationTabLabel,
  type LeadIntegrationContextTab,
} from './leadIntegrationContext.utils'
import classes from './integrationContextTabs.module.css'

type LeadIntegrationContextTabsProps = {
  leadLabel: string
  parents: CrmLeadParent[]
  activeTab: LeadIntegrationContextTab
  onChange: (tab: LeadIntegrationContextTab) => void
}

const LeadIntegrationContextTabs: FC<LeadIntegrationContextTabsProps> = ({
  leadLabel,
  parents,
  activeTab,
  onChange,
}) => {
  if (parents.length === 0) {
    return null
  }

  const isLeadActive = activeTab.type === 'lead'

  return (
    <div
      className={classes.root}
      role="tablist"
      aria-label="Контекст интеграций"
    >
      <button
        type="button"
        role="tab"
        aria-selected={isLeadActive}
        className={cn(classes.tab, isLeadActive && classes.tabActive)}
        onClick={() => onChange({ type: 'lead' })}
        title={leadLabel}
      >
        {leadLabel}
      </button>
      {parents.map((parent) => {
        const active =
          activeTab.type === 'parent' &&
          Number(activeTab.parentId) === Number(parent.id)
        const label = getParentIntegrationTabLabel(parent)
        return (
          <button
            key={parent.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={cn(classes.tab, active && classes.tabActive)}
            onClick={() =>
              onChange({ type: 'parent', parentId: Number(parent.id) })
            }
            title={label}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}

export default LeadIntegrationContextTabs
